(function ( $ ) {
    $.fn.scrollTo = function() {
        var that = this;
        return this.click(function(e) {
        var target = $(this).data('scroll-to');
        var timing = $(this).data('timing') || 500;
        // var offset = $(this).data('offset') || 130;
        e.preventDefault();
        if ($(target).length) {
            $(target).velocity("scroll", { duration: timing, easing: [0.44, 0.19, 0.24, 1] });
        };
      });
    };
}( jQuery ));


$(function(){
	if ($('.js-scroll-to').length) {
		$('.js-scroll-to').scrollTo();
	};
});